import React from "react";
import PropTypes from "prop-types";
import NoteBookIcon from "@learningblocks/protocol-constants/lib/Images/notebook-icon.svg";
import NoteBookIconHover from "@learningblocks/protocol-constants/lib/Images/notebook-icon-hover.svg";
import NoteBookIconCollapse from "@learningblocks/protocol-constants/lib/Images/notebook-icon-collapse.svg";
import { Image, LogEvent } from "@learningblocks/shared-components";
import "./style.scss";

export class DrawerHandle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
    };
  }
  mouseOver = () => this.setState({ hover: true });
  mouseOut = () => this.setState({ hover: false });

  handleIcon = () => {
    if (this.props.collapsed) return NoteBookIconCollapse;
    else if (this.state.hover) return NoteBookIconHover;
    else return NoteBookIcon;
  };

  handleIconAlt = () => {
    return "notebook-icon";
  };

  wrapperClass = () => {
    const classList = [
      "drawer-handle",
      this.props.collapsed ? "collapsed" : "expanded",
    ];
    return classList.join(" ");
  };

  onClick = (event) => {
    event.stopPropagation();
    this.props.toggleCollapse(!this.props.collapsed);
  };

  render() {
    return (
      <LogEvent
        logEventProps={{
          event_type: "sim_sidebar_minimize_btn clicked",
          event_schema: "track",
          collapsed: this.props.collapsed,
        }}
        actionProps={{ onClick: { action: "click" } }}
        elementType="button"
      >
        <span
          role="button"
          tabIndex={0}
          onClick={this.onClick}
          className={this.wrapperClass()}
          onMouseOver={this.mouseOver}
          onFocus={this.mouseOver}
          onMouseOut={this.mouseOut}
          onBlur={this.mouseOut}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              this.onClick();
            }
          }}
        >
          <Image src={this.handleIcon()} alt={this.handleIconAlt()} />
        </span>
      </LogEvent>
    );
  }
}

DrawerHandle.propTypes = {
  toggleCollapse: PropTypes.func,
  collapsed: PropTypes.bool.isRequired,
};
